import styled from "styled-components";

const ScreenWrapper = styled.div`
  width: 100%;
  flex: 1 1 auto;
  overflow-y: auto;
`;

export default ScreenWrapper;
